import React from 'react';

import {BreweriesHeader} from './BreweriesHeader';
import './BreweriesTable.scss';
import {BreweriesTableBody} from './BreweriesTableBody/BreweriesTableBody';

export const BreweriesTable = () => {
  return (
    <div className="breweries__table-container">
      <BreweriesHeader />
      <BreweriesTableBody />
    </div>
  );
};
